import React from "react";
import { FaTimes } from "react-icons/fa";
import { AppContext } from "../context";
import SocialIcons from "./SocialIcons";
import NavLinks from "./NavLinks";
import ToggleTheme from "./ToggleTheme";
import LangSwitch from "./LangSwitch";
import Logo from "./Logo";
import { useI18n } from "../i18n";

export const Sidebar = () => {
  // function from context
  const { isSidebarOpen, closeSidebar } = React.useContext(AppContext);
  const { t } = useI18n();

  // jsx
  return (
    <aside className={`${isSidebarOpen ? "sidebar show-sidebar" : "sidebar"}`}>
      {/* sidebar-header */}
      <div className="sidebar-header">
        <div className="sidebar-header-col">
          <Logo />
          <LangSwitch />
          <ToggleTheme />
        </div>
        <button className="close-btn" onClick={closeSidebar}>
          <FaTimes />
        </button>
      </div>
      <hr />

      {/* sidebar-links */}
      <ul className="sidebar-links">
        <NavLinks />
      </ul>

      {/* sidebar-icons */}
      <div className="sidebar-icons">
        <h4>{t.contact.social}</h4>
        <div className="icons-container">
          <SocialIcons />
        </div>
      </div>
    </aside>
  );
};
